const TIMEOUT_MS = 30 * 60 * 1000;
const WARNING_MS = 5 * 60 * 1000;
const STORAGE_KEY = "sessionLastActivity";

const LOGOUT_KEYS = [
  "token",
  "adminToken",
  "avatar",
  "account",
  "customerAccounts",
  "activeAccount",
  "accountName",
  "hostName",
  "sandbox",
  "hostTimeZone",
  "hostContext",
  "showBanner",
  "queryElement",
  "isLocal",
  "user",
  "pbxMap",
  "apiUrl",
  "apiToken",
  "services",
  "userPermissions",
  "modules",
  STORAGE_KEY,
];

export default {
  data() {
    return {
      sessionTimeoutWarning: false,
      sessionCountdown: 0,
    };
  },

  methods: {
    _updateActivity() {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
      if (this.sessionTimeoutWarning) {
        this.sessionTimeoutWarning = false;
        clearInterval(this._sessionCountdownInterval);
      }
    },

    _checkSession() {
      if (!localStorage.getItem("token")) return;

      const lastActivity = parseInt(localStorage.getItem(STORAGE_KEY) || "0");

      if (lastActivity === 0) {
        localStorage.setItem(STORAGE_KEY, Date.now().toString());
        return;
      }

      const elapsed = Date.now() - lastActivity;

      if (elapsed >= TIMEOUT_MS) {
        this.sessionTimeoutWarning = false;
        clearInterval(this._sessionCountdownInterval);
        this._sessionSignOut();
      } else if (
        elapsed >= TIMEOUT_MS - WARNING_MS &&
        !this.sessionTimeoutWarning
      ) {
        this.sessionTimeoutWarning = true;
        this.sessionCountdown = Math.round((TIMEOUT_MS - elapsed) / 1000);
        this._sessionCountdownInterval = setInterval(() => {
          this.sessionCountdown--;
          if (this.sessionCountdown <= 0) {
            clearInterval(this._sessionCountdownInterval);
            this._sessionSignOut();
          }
        }, 1000);
      }
    },

    _sessionSignOut() {
      clearInterval(this._sessionInterval);
      clearInterval(this._sessionCountdownInterval);
      LOGOUT_KEYS.forEach((k) => localStorage.removeItem(k));
      this.$store.dispatch("pbxMap", null);
      this.$store.dispatch("hostName", null);
      this.$store.dispatch("user", {});
      this.$store.dispatch("token", "");
      this.$store.dispatch("adminToken", "");
      this.$store.dispatch("userAvatar", "");
      this.$store.dispatch("account", "");
      this.$store.dispatch("services", []);
      this.$store.dispatch("modules", {});
      this.$router.push("/login");
    },

    sessionStayLoggedIn() {
      this._updateActivity();
    },
  },

  computed: {
    sessionCountdownFormatted() {
      const m = Math.floor(this.sessionCountdown / 60);
      const s = this.sessionCountdown % 60;
      return m > 0 ? `${m}m ${s.toString().padStart(2, "0")}s` : `${s}s`;
    },
  },

  mounted() {
    const token = localStorage.getItem("token");

    if (token) {
      const lastActivity = parseInt(localStorage.getItem(STORAGE_KEY) || "0");
      if (lastActivity > 0) {
        const elapsed = Date.now() - lastActivity;
        if (elapsed >= TIMEOUT_MS) {
          this._sessionSignOut();
          return;
        }
      }
    }

    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((e) =>
      window.addEventListener(e, this._updateActivity, { passive: true }),
    );

    this._sessionInterval = setInterval(this._checkSession, 60 * 1000);
  },

  beforeUnmount() {
    clearInterval(this._sessionInterval);
    clearInterval(this._sessionCountdownInterval);
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach((e) => window.removeEventListener(e, this._updateActivity));
  },
};
